module.exports = {"TXTCLI_Address":{"id":"TXTCLI_Address","defaultMessage":"Adresse","flags":["TRACK"],"track":"Address"}}